import {Injectable} from '@angular/core';
import {SectionsContainer} from './sections-container';

@Injectable({
  providedIn: 'root'
})
export class FieldValidationService {

  constructor() {
  }

  isFieldInvalid(sectionsContainer: SectionsContainer, formControlName: string) {
    const field = sectionsContainer.formGroup.controls[formControlName];
    let res = false;
    if (field) {
      // Since the form.ngSubmit.emit() doesn't cause form.submitted to be set, need to use attribute from sections container
      res = (field.touched || !field.pristine || sectionsContainer.form.submitted || sectionsContainer.submitted) && field.invalid;
    } else {
      console.warn('Field key \'' + formControlName + '\' not found in form group controls');
    }
    return res;
  }
}
